import Modals from "components/modal";
import { useTranslation } from "react-i18next";
import { Button } from "antd";

const VideoErrorModal = ({
  description = "card-page.camera-description",
  title = "card-page.not-access-to-camera",
  errorModalRef,
  onClick,
}) => {
  const { t } = useTranslation();

  return (
    <Modals
      width="90%"
      title={t(title)}
      reference={errorModalRef}
      className="max-w-md onb-info-modal"
      footer={null}
    >
      <div className="flex flex-col">
        <span>{t(description)}</span>
        <Button
          block
          className="primary-button-large mt-4 justify-center "
          onClick={onClick}
        >
          {t("card-page.accept")}
        </Button>
      </div>
    </Modals>
  );
};
export default VideoErrorModal;
